// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"388":"4df40155","424":"7b2fa5af"}[chunkId] + ".css";
};